import { render, staticRenderFns } from "./NotificationsClient.vue?vue&type=template&id=ced1e668"
import script from "./NotificationsClient.vue?vue&type=script&lang=js"
export * from "./NotificationsClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports